export default __webpack_public_path__ + "static/media/Fuzzy_Fan.c1db773e.mp3";